var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isECommerceProduct)?_c('nissan-footer'):_c('upgrade-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }